import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useTheme } from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';

var mediaBreakpointHelper = function mediaBreakpointHelper(breakpoints, breakpoint) {
  var split = breakpoint.split('_');
  var shirtSize = split[0];
  var strategy = split[1] || 'gte';
  if (!breakpoints) {
    return 'all';
  }
  var keys = Object.keys(breakpoints);
  var value = breakpoints[shirtSize];
  var index = keys.indexOf(shirtSize);
  if (index < 0) {
    throw new Error("The breakpoint size '" + shirtSize + "' does not exist on the theme. Use one of " + keys.map(function (k) {
      return "'" + k + "'";
    }).join(', ') + ".");
  }
  if (['lte', 'eq', 'gte'].indexOf(strategy) < 0) {
    throw new Error("The strategy '" + strategy + "' is not valid for breakpoint '" + breakpoint + "'. Use one of '" + shirtSize + "_lte', '" + shirtSize + "_eq', '" + shirtSize + "_gte'.");
  }
  var min = '';
  if (strategy !== 'lte') {
    min = "(min-width: " + value + "px)";
  }
  var max = '';
  if (strategy !== 'gte' && index < keys.length - 1) {
    max = "(max-width: " + (breakpoints[keys[index + 1]] - 1) + "px)";
  }
  if (min || max) {
    return "" + min + (min && max ? ' and ' : '') + max;
  }
  return 'all';
};
var Source = function Source(props) {
  var theme = useTheme();
  var media = props.media;
  return /*#__PURE__*/React.createElement("source", _extends({}, props, {
    media: media ? mediaBreakpointHelper(theme.constellation.breakpoints, media) : null
  }));
};
Source.propTypes = process.env.NODE_ENV !== "production" ? {
  srcSet: PropTypes.string,
  loading: PropTypes.string,
  media: PropTypes.string
} : {};
Source.defaultProps = {};
/** @component */
var Source$1 = Source;

export { Source$1 as default, mediaBreakpointHelper };
